import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { ReactiveComponentModule } from '@ngrx/component';

import { EditorModule } from '@tinymce/tinymce-angular';

import { ColorPickerModule } from 'ngx-color-picker';

import { ChartsModule } from 'ng2-charts';

import { HeaderComponent } from './components/header/header.component';
import { AngularMaterialModule } from '../material/angular-material.module';
import { CoreModule } from '../core/core.module';
import { LoaderComponent } from './components/loader/loader.component';
import { ReleaseNotesListComponent } from './components/release-notes-list/release-notes-list.component';
import { DialogTitleComponent } from './components/dialog-title/dialog-title.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';

@NgModule({
  declarations: [
    HeaderComponent,
    LoaderComponent,
    ReleaseNotesListComponent,
    DialogTitleComponent,
    SidenavComponent,
    ImageUploadComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule,
    RouterModule,
    CoreModule,
    ChartsModule,
    ReactiveComponentModule,
    ReactiveFormsModule,
    EditorModule,
    ColorPickerModule,
  ],
  exports: [
    HeaderComponent,
    LoaderComponent,
    ReleaseNotesListComponent,
    DialogTitleComponent,
    SidenavComponent,
    ChartsModule,
    ReactiveComponentModule,
    ImageUploadComponent,
    EditorModule,
    ColorPickerModule,
  ],
})
export class SharedModule {}
